import React from "react";
import { OverlayEdit } from ".";
import { AnswerHelper, ApiHelper, ArrayHelper, OverlayInterface, ScreenInterface, TemplateInterface } from "../../helpers";

interface Props {
  screen: ScreenInterface
  scheduleId: number,
  saveCallback: (scheduleId: number) => void,
  pendingCommand: { action: string, parameter: string }
}

export const Overlays: React.FC<Props> = props => {

  const [overlays, setOverlays] = React.useState<OverlayInterface[]>(null);
  const [selectedIndex, setSelectedIndex] = React.useState<number>(-1);
  const [templates, setTemplates] = React.useState<TemplateInterface[]>(null);
  const [deleteIds, setDeleteIds] = React.useState<number[]>([]);


  const init = () => { loadData() }

  const loadData = async () => {
    setOverlays([])
    if (props.scheduleId > 0) {
      const data = await ApiHelper.get<OverlayInterface[]>("/overlays/schedule/" + props.scheduleId) || [];
      setOverlays(data);
      const tData = await ApiHelper.get<TemplateInterface[]>("/templates/available") || [];
      const result: TemplateInterface[] = [];
      tData.forEach(d => { if (d.templateType === "overlay") result.push(d); });
      setTemplates(result)

    }
  }

  const handleAdd = (e: React.MouseEvent) => {
    e.preventDefault();
    const tmpOverlays = [...overlays];
    tmpOverlays.push({ templateId: 5, position: "top" });
    setOverlays(tmpOverlays);
    setSelectedIndex(tmpOverlays.length - 1);
  }

  const getRows = () => {
    const result: React.ReactElement[] = [];
    let idx = 0;
    overlays?.forEach(o => {
      const index = idx;
      const template = ArrayHelper.getOne(templates || [], "id", o.templateId)
      result.push(<tr key={"o_" + o.id + "_" + index}>
        <td>
          <a href="about:blank" onClick={(e) => { e.preventDefault(); setSelectedIndex(index); }} >
            {template?.name || o.templateId}
          </a>
        </td>
        <td>{o.position}</td>
        <td className="action-cell">
          <a href="about:blank" className="text-danger" onClick={(e: React.MouseEvent) => { e.preventDefault(); handleDelete(index) }}><i className="fas fa-trash-alt"></i> Delete</a>
        </td>
      </tr>);
      idx++;
    });
    return result;
  }

  const handleDelete = (index: number) => {
    const o = overlays[index];

    if (o.id && deleteIds.indexOf(o.id) === -1) {
      let deleteIdsCopy: number[] = [...deleteIds];
      deleteIdsCopy.push(o.id)
      setDeleteIds(deleteIdsCopy);
    }

    let overlaysCopy: OverlayInterface[] = [...overlays];
    overlaysCopy.splice(index, 1);
    setOverlays(overlaysCopy);
  }

  const handleSave = async (scheduleId: number) => {
    overlays.forEach(sp => sp.scheduleId = scheduleId);
    const promises: Promise<any>[] = []
    if (deleteIds.length > 0) {
      deleteIds.forEach(id => { promises.push(ApiHelper.delete("/overlays/" + id)) });
      await Promise.all(promises);
    }
    if (overlays.length > 0) {
      for (let overlay of overlays) {
        const o = { ...overlay };
        o.answers = null;
        const result = await ApiHelper.post<OverlayInterface[]>("/overlays", [o]) || [];
        if (overlay.answers) {
          overlay.answers.forEach(a => { a.overlayId = result[0].id; });
          const questions = await ApiHelper.getAnonymous<any[]>("/questions/template/" + overlay.templateId.toString()) || [];
          await AnswerHelper.preSave(overlay.answers, questions, (percent) => { });
          await ApiHelper.post("/answers", overlay.answers);
        }
      }
    }
    props.saveCallback(scheduleId)
  }

  const handleParentCommand = () => {
    if (props.pendingCommand) {
      if (props.pendingCommand.action === "save") handleSave(parseInt(props.pendingCommand.parameter, 0))
    }
  }


  React.useEffect(init, [props.scheduleId, props.screen?.rotation]); // eslint-disable-line
  React.useEffect(handleParentCommand, [props.pendingCommand]); // eslint-disable-line

  const handleEditUpdate = (data: OverlayInterface) => {
    const tmpOverlays = [...overlays];
    tmpOverlays[selectedIndex] = data;
    setOverlays(tmpOverlays);
    setSelectedIndex(-1);
  }

  const getContent = () => {
    if (selectedIndex >= 0) return <OverlayEdit overlay={overlays[selectedIndex]} templates={templates} onUpdate={handleEditUpdate} />
    else return (<table className="table table-sm">
      <thead>
        <tr><th>Type</th><th>Position</th><th>Action</th></tr>
      </thead>
      <tbody>
        {getRows()}
        <tr><td colSpan={3} className="action-cell text-end">
          <a href="about:blank" className="text-success" onClick={handleAdd}><i className="fas fa-plus"></i> Add</a>
        </td></tr>
      </tbody>
    </table>)
  }



  return (
    <>
      <div className="section">Overlays</div>
      {getContent()}
    </>
  );
}
